import store from '../store/store';


export function setGlobalContext(data) {
	store.dispatch({
		type: 'globalContext.setGlobalContext',
		appStatePath: getGlobalContextPath(),
		data
	});
}

export function getGlobalContextPath() {
	return ['globalContext'];
}
